import claudeLogo from 'images/bumperMcp/claude-logo.png';
import { McpClient } from 'routes/Mcp/constants';

import { ChatGptBadge, IconBox } from './iconStyledComponents';
import { McpImage } from './styled';

interface McpClientIconProps {
  client: McpClient;
  size: number;
}

/** Decorative brand glyph for an MCP client; the label always sits next to it. */
export const McpClientIcon = ({ client, size }: McpClientIconProps) => {
  if (client === 'claude') {
    return (
      <McpImage src={claudeLogo} alt="" style={{ width: size, height: size }} />
    );
  }

  if (client === 'chatgpt') {
    return (
      <ChatGptBadge aria-hidden size={size}>
        <svg
          width={size * 0.66}
          height={size * 0.66}
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 3.2l6.6 3.8v7.6L12 18.4l-6.6-3.8V7zM12 3.2v7.4M5.4 7l6.6 3.6 6.6-3.6M5.4 14.6 12 10.6l6.6 4" />
        </svg>
      </ChatGptBadge>
    );
  }

  return (
    <IconBox aria-hidden>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M8 9l-3 3 3 3M13 15h4" />
        <rect x="3" y="4" width="18" height="16" rx="2" />
      </svg>
    </IconBox>
  );
};
